<article class="d-flex flex-column w-100">
  <ng-content select="[row-header]" />
  <div class="row-scroll">
    <div class="row-scroll-inner d-flex flex-column">
      <ng-content select="[row-chart]" />
      <ng-content select="[row-events]" />
    </div>
  </div>
  <ng-content select="[row-table]" />
</article>
